module.exports = __webpack_public_path__ + "static/media/Mariadb-seal-browntext.217110d7.svg";